/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
var Hammer = function (quality) {
  return {
    slot: 'weapon',
    type: 'hammer',
    quality: quality,
    damageMod: quality * 0.35,
    strength: Math.round(1 + quality * 2.5),
    willpower: Math.round(1 + quality * 3.5),
  };
};
module.exports = Hammer;
